// useCoordinationCaps(projectId) - which coordination tabs a PARTNER gets on
// one project (owner, 2026-10-15: the coordination tabs per partner, per
// project, switched on from the Partners page).
//
//   const caps = useCoordinationCaps(projectId);
//   caps === null           not a partner here, no project, or not known yet:
//                           the caller keeps its own key check (today's rule)
//   caps.tabs.shopDrawings  { view, add, edit, delete }
//
// Only asked for a partner account (userInfo.partnerAccount, not a platform
// admin): the project team's tabs are their own permission keys, unchanged.
// One request per person per project for the life of the page - the strip and
// the drawer both mount on every coordination route. A failed answer is not
// cached and leaves today's rule in place, so a network blip never hides a tab
// the person had a moment ago.
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getMyCoordinationCaps } from "api/partners/coordinationGrantsApi";

const cache = {};
export function capsFor(userId, projectId) {
  const key = `${userId}:${projectId}`;
  if (!cache[key]) {
    cache[key] = getMyCoordinationCaps(projectId)
      .then((r) => (r && r.partner ? r : null))
      .catch(() => { delete cache[key]; return null; });
  }
  return cache[key];
}
// Tests reset between cases.
export function clearCoordinationCaps() {
  Object.keys(cache).forEach((k) => delete cache[k]);
}

export default function useCoordinationCaps(projectId) {
  const userInfo = useSelector((s) => s.user?.userInfo);
  const userId = userInfo?._id || userInfo?.id;
  const partner = !!userInfo?.partnerAccount && !userInfo?.admin;
  const [caps, setCaps] = useState(null);
  useEffect(() => {
    let live = true;
    setCaps(null);
    if (!partner || !userId || !projectId) return undefined;
    capsFor(userId, projectId).then((c) => { if (live) setCaps(c); });
    return () => { live = false; };
  }, [partner, userId, projectId]);
  return caps;
}
